import React, { useEffect, useState } from 'react'
import Translate from 'App/i18n'
import { verifyEmail } from 'App/helpers/meteor-apollo-accounts'
import PropTypes from 'prop-types'
import { useApolloClient } from '@apollo/client'
import { useNavigate, useOutletContext } from 'react-router-dom'
import track from 'App/helpers/track'
import useMessage from 'App/hooks/useMessage'

export default function VerifyEmail({ token }) {
  const client = useApolloClient()
  const navigate = useNavigate()
  const showMessage = useMessage()
  const [error, setError] = useState(null)
  const { setLoading } = useOutletContext()

  useEffect(() => {
    const verifyFunc = async () => {
      try {
        setLoading(true)
        await verifyEmail({ token }, client)
        track({ category: 'register', action: 'verify-email' })
        navigate('/accounts')
        setLoading(false)
        client.resetStore()
      } catch (error) {
        console.error(error)
        showMessage(error.message)
        track({ category: 'register', action: 'verify-email-error', label: error.message })
        navigate('/verify-email')
        setLoading(false)
        setError(error)
      }
    }
    // Delay the function execution by 2000 ms
    const timeoutId = setTimeout(verifyFunc, 2000)

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timeoutId)
  }, [token, client, showMessage, setLoading, navigate])

  if (error) {
    return <div className="center-align">{error.message}</div>
  } else {
    return (
      <div className="center-align">
        <Translate tr="auth.verifyEmail.verifying" />
      </div>
    )
  }
}

VerifyEmail.propTypes = {
  token: PropTypes.string,
  setLoading: PropTypes.func,
}
